    <template>
        <div class="search-bar mb-1">
            <h2 class="sr-only">{{ $t('searchBar.heading') }}</h2>
            <div class="d-flex p-1 p-sm-1 p-md-1 p-lg-3 p-xl-4">
                <search-input v-model="searchTerm" :placeholder="$t('searchBar.inputPlaceholder')" />

                <!-- ARIA Live Region for Announcing Updates -->
                <div id="global-search-scr-output" aria-live="assertive" class="sr-only"></div>
            </div>
            <hr class="white-space" v-if="searchedName"/>
            <div role="tablist" class="d-flex flex-grow-1 flex-column overflow-auto mb-5" v-if="searchedName || searchedSection">
                <div class="d-flex justify-content-between" v-if="searchedName">
                    <h5 class="pl-4 break-word" v-html="searchedName"></h5>
                    <button class="btn-close mr-8" @click="closeSearch"><f-icon-close aria-label="close" title="close"/></button>
                </div>

                <template v-if="searchedSection === 'section-5'">
                    <nav-section id="section-5" :title="$t('sideNav.community')" :is-expanded="activeSection === 'section-5'" @click="activeSection = 'section-5'">
                        <nav-item :label="$t('sideNav.activities')" route="gemeinden.activities" :routeParams="{ platform: platformUuid, }" :exact="false">
                            <f-icon-activities title="side nav item icon"/>
                        </nav-item>

                        <nav-item :label="$t('sideNav.information')" route="gemeinden.information" :routeParams="{ platform: platformUuid, }" :exact="false">
                            <f-icon-info title="side nav item icon"/>
                        </nav-item>

                        <nav-item :label="$t('sideNav.groups')" route="gemeinden.groups" :routeParams="{ platform: platformUuid, }" :exact="false">
                            <f-icon-groups title="side nav item icon"/>
                        </nav-item>

                        <nav-item :label="$t('sideNav.clubs')" route="gemeinden.clubs" :routeParams="{ platform: platformUuid, }" :exact="false">
                            <f-icon-clubs title="side nav item icon"/>
                        </nav-item>

                        <nav-item :label="$t('sideNav.business')" route="gemeinden.business" :routeParams="{ platform: platformUuid, }" :exact="false">
                            <f-icon-business title="side nav item icon"/>
                        </nav-item>

                        <nav-item :label="$t('sideNav.institutions')" route="gemeinden.institutions" :routeParams="{ platform: platformUuid, }" :exact="false">
                            <f-icon-institution title="side nav item icon"/>
                        </nav-item>
                    </nav-section>
                </template>

                <template v-if="searchedSection === 'section-6'">
                    <nav-section id="section-6" :title="$t('sideNav.neighbourhood')" :is-expanded="activeSection === 'section-6'" @click="activeSection = 'section-6'">
                        <nav-item :label="$t('sideNav.information')" route="nachbarschaft.information" :routeParams="{ platform: platformUuid, }" :exact="false">
                            <f-icon-info title="side nav item icon"/>
                        </nav-item>
                    </nav-section>
                </template>

                <template v-if="searchedSection === 'section-7'">
                    <nav-section id="section-7" :title="$t('sideNav.groups')" :is-expanded="activeSection === 'section-7'" @click="activeSection = 'section-7'">
                        <nav-item :label="$t('sideNav.information')" route="gruppe.information" :routeParams="{ group: groupUuid, }" :exact="false">
                            <f-icon-info title="side nav item icon"/>
                        </nav-item>
                    </nav-section>
                </template>

                <template v-if="searchedSection === 'section-8'">
                    <nav-section id="section-8" :title="$t('sideNav.clubs')" :is-expanded="activeSection === 'section-8'" @click="activeSection = 'section-8'">
                        <nav-item :label="$t('sideNav.information')" route="vereine.information" :routeParams="{ group: groupUuid, }" :exact="false">
                            <f-icon-info title="side nav item icon"/>
                        </nav-item>
                    </nav-section>
                </template>

                <template v-if="searchedSection === 'section-9'">
                    <nav-section id="section-9" :title="$t('sideNav.institutions')" :is-expanded="activeSection === 'section-9'" @click="activeSection = 'section-9'">
                        <nav-item :label="$t('sideNav.information')" route="institutionen.information" :routeParams="{ group: groupUuid, }" :exact="false">
                            <f-icon-info title="side nav item icon"/>
                        </nav-item>
                    </nav-section>
                </template>

                <template v-if="searchedSection === 'section-10'">
                    <nav-section id="section-10" :title="$t('sideNav.business')" :is-expanded="activeSection === 'section-10'" @click="activeSection = 'section-10'">
                        <nav-item :label="$t('sideNav.information')" route="gewerbe.information" :routeParams="{ group: groupUuid, }" :exact="false">
                            <f-icon-info title="side nav item icon"/>
                        </nav-item>
                    </nav-section>
                </template>

                <template v-if="searchedSection === 'section-11'">
                    <nav-section id="section-11" :title="$t('sideNav.local_government')" :is-expanded="activeSection === 'section-11'" @click="activeSection = 'section-11'">
                        <nav-item :label="$t('sideNav.information')" route="gemeindeverwaltungen.information" :routeParams="{ group: groupUuid, }" :exact="false">
                            <f-icon-info title="side nav item icon"/>
                        </nav-item>
                    </nav-section>
                </template>
            </div>
        </div>
    </template>

    <script type="ts">
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import SearchInput from '@/modules/main/components/SearchInput.vue';
    import {ACTIONS} from "@/modules/main/store/globalSearchModule";
    import NavSection from '@/modules/main/components/Nav/NavSection.vue';
    import NavItem from '@/modules/main/components/Nav/NavItem.vue';
    import FIconActivities from '@/modules/main/components/icons/FIconActivities.vue';
    import FIconInfo from '@/modules/main/components/icons/FIconInfo.vue';
    import FIconGroups from '@/modules/main/components/icons/FIconGroups.vue';
    import FIconClubs from '@/modules/main/components/icons/FIconClubs.vue';
    import FIconBusiness from '@/modules/main/components/icons/FIconBusiness.vue';
    import FIconInstitution from '@/modules/main/components/icons/FIconInstitution.vue';
    import FIconClose from '@/modules/main/components/icons/FIconClose.vue';
    import { BNavItem } from 'bootstrap-vue';
    import { store } from '@/modules/main/store';
    import { searchSections } from '@/store/searchModule';

    @Component({
        components: {
            SearchInput,
             FIconInfo,
             FIconActivities,
             FIconGroups,
             FIconClubs,
             FIconBusiness,
             FIconInstitution,
             NavSection,
             NavItem,
             BNavItem,
             FIconClose,
        },
    })
    export default class SearchBar extends Vue {

        searchTerm = '';
        activeSection = '';

        staticSection = ['fuerenand', 'belvita', 'login', ''];

        get isStaticPage() {
            return this.staticSection.includes(window.location.pathname.split('/')[1]);
        }

        get platformUuid() {
            return this.$route.params.platform || store.state.globalSearch.globalSearchUuid;
        }

        get groupUuid() {
            return this.$route.params.group || store.state.globalSearch.globalSearchUuid;
        }

        @Watch('searchTerm')
        onSearchTerm() {
            if (this.searchTerm.length > 2) {
                setTimeout(() => {
                    if (this.$router.currentRoute.name !== 'search') {
                        this.$store.dispatch(ACTIONS.SET_PREVIOUS_VISITED_PAGE, this.$router.currentRoute.fullPath);
                        this.$router.push({name: 'search'}).catch(() => {
                        });
                    } else if (!store.state.globalSearch.previousVisitedPage) {
                        this.$store.dispatch(ACTIONS.SET_PREVIOUS_VISITED_PAGE, this.$router.currentRoute.fullPath);
                    }

                    this.$store.dispatch(ACTIONS.SET_GLOBAL_SEARCH_TERM, this.searchTerm);

                    if (this.isStaticPage) {
                        setTimeout(() => {
                            window.location.href = '/search?term=' + this.searchTerm;
                        }, 800);
                    }
                }, 500);
            }

            if (this.searchTerm && this.searchTerm.length < 3 && this.$router.currentRoute.name === 'search' && !this.urlParams) {
                this.$router.go(-1);
            }
        }

        get urlParams () {
            const params = new URLSearchParams(window.location.search.substring(1));

            return params.get('term');
        }

        get searchedName() {
            if (this.searchedSection === 'section-6' && store.state.globalSearch.globalSearchSubTitle) {
                return store.state.globalSearch.globalSearchSubTitle;
            }

            return store.state.globalSearch.globalSearchTitle;
        }

        get searchedSection() {
            return store.state.globalSearch.globalSearchSection;
        }

        closeSearch() {
            this.$store.dispatch(ACTIONS.SET_GLOBAL_SEARCH_TITLE, '');
            this.$store.dispatch(ACTIONS.SET_GLOBAL_SEARCH_TERM, '');
            this.$store.dispatch(ACTIONS.SET_GLOBAL_SEARCH_SECTION, '');
            this.$store.dispatch(ACTIONS.SET_GLOBAL_SEARCH_SUBTITLE, '');
            this.$store.dispatch(ACTIONS.SET_GLOBAL_SEARCH_LOGO, '');
            this.$store.dispatch(ACTIONS.SET_GLOBAL_SEARCH_HEADER, '');
            const activeSection = this.activeSection;
            this.activeSection = '';
            const previousPath = store.state.globalSearch.previousVisitedPage;
            this.$store.dispatch(ACTIONS.SET_PREVIOUS_VISITED_PAGE, '');
            this.searchTerm = '';
            if (!previousPath) {
                this.$router.go(-1);
            }

            if (searchSections[activeSection]) {
                this.$router.push({path: previousPath}).catch(() => {});
            }
        }

        @Watch('$route')
        onRouteChange() {
            const sectionFromRoute = this.$route.meta?.sideNav;

            if (sectionFromRoute) {
                this.activeSection = sectionFromRoute;
            }
        }
    }
    </script>

    <style lang="scss">
    @import '~styles/essentials';

    .search-bar {
        background: $gray-200;

        .card {
            background: $gray-200;
        }

        .btn-close {
            background: none;
            border: none;
        }

        .white-space {
            margin-top: 0;
            border-top: 4px solid $white;
        }

        .break-word {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    </style>
